import { FormControl } from "./form";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "./select";

export const TimeSelect = ({ onChange, value }: { onChange: (value: string) => void; value: string }) => {
  return (
    <Select onValueChange={onChange} value={value}>
      <FormControl>
        <SelectTrigger>
          <SelectValue />
        </SelectTrigger>
      </FormControl>
      <SelectContent>
        <SelectItem value="00:00">12:00 AM</SelectItem>
        <SelectItem value="00:30">12:30 AM</SelectItem>
        <SelectItem value="01:00">01:00 AM</SelectItem>
        <SelectItem value="01:30">01:30 AM</SelectItem>
        <SelectItem value="02:00">02:00 AM</SelectItem>
        <SelectItem value="02:30">02:30 AM</SelectItem>
        <SelectItem value="03:00">03:00 AM</SelectItem>
        <SelectItem value="03:30">03:30 AM</SelectItem>
        <SelectItem value="04:00">04:00 AM</SelectItem>
        <SelectItem value="04:30">04:30 AM</SelectItem>
        <SelectItem value="05:00">05:00 AM</SelectItem>
        <SelectItem value="05:30">05:30 AM</SelectItem>
        <SelectItem value="06:00">06:00 AM</SelectItem>
        <SelectItem value="06:30">06:30 AM</SelectItem>
        <SelectItem value="07:00">07:00 AM</SelectItem>
        <SelectItem value="07:30">07:30 AM</SelectItem>
        <SelectItem value="08:00">08:00 AM</SelectItem>
        <SelectItem value="08:30">08:30 AM</SelectItem>
        <SelectItem value="09:00">09:00 AM</SelectItem>
        <SelectItem value="09:30">09:30 AM</SelectItem>
        <SelectItem value="10:00">10:00 AM</SelectItem>
        <SelectItem value="10:30">10:30 AM</SelectItem>
        <SelectItem value="11:00">11:00 AM</SelectItem>
        <SelectItem value="11:30">11:30 AM</SelectItem>
        <SelectItem value="12:00">12:00 PM</SelectItem>
        <SelectItem value="12:30">12:30 PM</SelectItem>
        <SelectItem value="13:00">01:00 PM</SelectItem>
        <SelectItem value="13:30">01:30 PM</SelectItem>
        <SelectItem value="14:00">02:00 PM</SelectItem>
        <SelectItem value="14:30">02:30 PM</SelectItem>
        <SelectItem value="15:00">03:00 PM</SelectItem>
        <SelectItem value="15:30">03:30 PM</SelectItem>
        <SelectItem value="16:00">04:00 PM</SelectItem>
        <SelectItem value="16:30">04:30 PM</SelectItem>
        <SelectItem value="17:00">05:00 PM</SelectItem>
        <SelectItem value="17:30">05:30 PM</SelectItem>
        <SelectItem value="18:00">06:00 PM</SelectItem>
        <SelectItem value="18:30">06:30 PM</SelectItem>
        <SelectItem value="19:00">07:00 PM</SelectItem>
        <SelectItem value="19:30">07:30 PM</SelectItem>
        <SelectItem value="20:00">08:00 PM</SelectItem>
        <SelectItem value="20:30">08:30 PM</SelectItem>
        <SelectItem value="21:00">09:00 PM</SelectItem>
        <SelectItem value="21:30">09:30 PM</SelectItem>
        <SelectItem value="22:00">10:00 PM</SelectItem>
        <SelectItem value="22:30">10:30 PM</SelectItem>
        <SelectItem value="23:00">11:00 PM</SelectItem>
        <SelectItem value="23:30">11:30 PM</SelectItem>
      </SelectContent>
    </Select>
  );
};
